import { initContext } from '@/base/context-init'
import App from './App.vue'

await initContext('payment', App)
